import { render, staticRenderFns } from "./NewsroomItemEditor.vue?vue&type=template&id=c51a1fce&"
import script from "./NewsroomItemEditor.vue?vue&type=script&lang=js&"
export * from "./NewsroomItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c51a1fce')) {
      api.createRecord('c51a1fce', component.options)
    } else {
      api.reload('c51a1fce', component.options)
    }
    module.hot.accept("./NewsroomItemEditor.vue?vue&type=template&id=c51a1fce&", function () {
      api.rerender('c51a1fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Newsroom/Components/Editor/NewsroomItemEditor.vue"
export default component.exports